<template>
    <div class='h-dialogContainer h-nomargin'>
        <div class='height-320 row m-b-10'>
            <div class='col-sm-5 nopadding:last-child'>
                <div class='h-borderBox height-320'>
                    <div class='h-borderBox-top' >
                        <ejs-textbox  :placeholder='$t("Software.enterKeywordSearch")' @keydown.enter.native="searchMethod" v-model='input'/>
                    </div>
                    <ejs-grid ref="listNe" :dataSource='listdata' height='220'>
                        <e-columns>
                            <e-column type='checkbox' width='10' ></e-column>
                            <e-column field='text' :headerText='$t("Software.td_neID")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class='col-sm-7 nopadding:first-child'>
                <div class='h-borderBox height-320'>
                    <verlib-list ref='veblist' :update='false' :hasBorder='true'></verlib-list>
                </div>
            </div>
        </div>
        <div class='b-t row h-row-around-inputBox'/>
        <div class='row' >
            <div class='h-col-inputBox h-marginT28 col-sm-12 nopadding'>
                <div class='col-sm-7 row nopadding'>
                    <div class='h-inputLit'>{{$t('Software.td_executionTime')}}</div>
                    <ejs-datetimepicker  :format="format" :timeFormat='timeFormat' v-model='timevalue'></ejs-datetimepicker>
                </div>
            </div> 
            <div class='h-col-inputBox col-sm-12 ' style="padding:0 0px;">
                <div class='col-sm-7'>
                    <div class='h-inputLit'>{{$t('Software.updataOper')}}</div>
                    <div v-for='(item,index) in udOperlist' :key='index' class='col-sm-3 nopadding'>
                        <ejs-checkbox :label='item.label' v-model='item.checked'/>
                    </div>
                </div>
            </div>
            <div class='h-col-inputBox col-sm-12 nopadding' style="padding:0 0px;">
                <div class="col-sm-1 row nopadding">
                    <span class="icon hero-icon hero-icon-detailed" style="line-height: 21px;padding:0 10px;">
                </span>
                </div>
                <div class='col-sm-7 row' >
                    <div style="padding:0 10px;">{{$t('Software.caution')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VerlibList from './VerlibList';
import TopoTree from '../topoconfig/TopoTree';
import {stringify} from 'qs';
import { isNullOrUndefined } from "@syncfusion/ej2-base";
let Source =[];
Date.prototype.Format = function (fmt) {  
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "H+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
export default {
    name: 'version-task',
    props: ['showToast'],
    components:{
        VerlibList,
        TopoTree
    },
    data() {
        return{
            format: 'yyyy-MM-dd HH:mm:ss',
            timeFormat: 'HH:mm:ss',
            timevalue: new Date(),
            listdata: [],
            input:'',
            udOperlist: [
                {
                    label: this.$t('Software.download'),
                    value: '1',
                    checked: false
                }, {
                    label: this.$t('Software.active'),
                    value: '2',
                    checked: false
                }, {
                    label: this.$t('Software.dataUpload'),
                    value: '0',
                    checked: false
                }]
        }
    },
    methods: {
        _getNeTreeData() {
            this.listdata = [];
            this.$axios.post('/lte/ems/auth/findEquipmentListByAuth',[]).then((response) => {
                const _nodeArray = response.data;
                const showData = [];
                const showPrimaryDatas = [];
                _nodeArray.forEach((_item) => {
                    const { id, name, equipmentIP, equipmentIPId, typeCode } = _item;
                    const _dataItem = {
                        text: name,
                        id: id,
                        neType: typeCode,
                        tooltip: equipmentIP,
                        equipmentIPId: equipmentIPId
                    };
                    showData.push(_dataItem);
                });
                this.listdata = showData;
                Source = showData;
            });
        },
        updateVersion(callback) {
            const checkNodes = this.$refs.listNe.getSelectedRecords();
            const NeIdList = Array.from(checkNodes, x => { return x.id });
            if(NeIdList.length == 0)
            {
                this.showToast('warning', `${this.$t('Software.selectDevice')}`);
                return;
            }
            const checkPkg = Array.from(this.$refs.veblist.getSelect(), x => { return x.pkgId });
            let para = {
                neIdList: NeIdList,
                pkgList: checkPkg
            }
            let config = {
                headers: {
                    "Content-Type": "application/json"
                }
            };
            let params = {
                isDownLoad: this.udOperlist[0].checked ? 1:0,
                isActive: this.udOperlist[1].checked ? 1:0,
                isUpLoad: this.udOperlist[2].checked ? 1:0,
                execTime: new Date(this.timevalue).Format("yyyy-MM-dd HH:mm:ss"),
                systemId: "1",
                isfilter: 0,
            };
            if(params.isDownLoad === 0 && params.isActive === 0 && params.isUpLoad === 0)
            {
                this.showToast('warning', `${this.$t('Software.selectOprType')}`);
                return;
            }
            this.axios.post(`/lte/ems/verupdate_new/updateVerAction?${stringify(params)}`, JSON.stringify(para), config).then(response => {
                console.log("update", response);
                callback();
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.showToast('success', `${this.$t('Common.tips.success')}`);
                        console.log('update', response);
                    }
                    else {
                        this.showToast('error',response.data.errorString);
                    }
                }
                else{
                    this.showToast('error', `${this.$t('Common.tips.failure')}`);
                }
            });
        },

        searchMethod()
        {
            if(this.input === '') {
                this.listdata = Source;
            }
            else{
                this.listdata = this.search(this.input,Source,this.$refs.listNe.getColumns())
            }
        },
        search(input,source,columns,maparray) {
            var filterdata = source.filter( item => {
                let columntext = Array.from(columns, x => {
                    return x.field;
                });
                let feildData = Array.from(columntext, x => {
                    if(maparray && maparray.has(x)){
                        let value = maparray.get(x).get(item[x]);
                        return isNullOrUndefined(value) ? '' : value;
                    }
                    else{
                        return isNullOrUndefined(item[x]) ? '' : item[x] +'';
                    }
                });
                let filres = false;
                feildData.forEach(item => {
                    if(item.indexOf(input) > -1)
                    {
                        filres = true;
                    }
                });
                return filres;
            }).map( item => { return item });
            return filterdata;
        },
    }
}
</script>>